/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { urlB64ToUint8Array } from '@/assets/js/utils';
import { getDeviceId } from '@/assets/js/utils.js';
import { InitWebpush } from '@/api/index';
import store from './store';

let isSubscribed = false;
const urlParams = new URLSearchParams(window.location.search);

// const timestamp = new Date().getTime();
// if ('serviceWorker' in window.navigator && process.env.NODE_ENV === 'production') {
const getPulicKey = async () => {
  if (store.state.appInfo.key === '') {
    const data = await store.dispatch('getAppInfo', {
      app_id:
        process.env.NODE_ENV === 'development'
          ? 'ddz.test.hzbc.top'
          : window.location.host,

      pixel_click_id: urlParams.get('pixel_click_id')
        ? urlParams.get('pixel_click_id')
        : '',
      _oks_ext: urlParams.get('_oks_ext') ? urlParams.get('_oks_ext') : '',
      code: urlParams.get('code') ? urlParams.get('code') : '',
    });
    return data.key;
  } else {
    return store.state.appInfo.key;
  }
};

setTimeout(() => {
  register(`./sw.js`, {
    async ready() {
      console.log('App is being served from cache by a service worker.');
    },
    async registered(registration) {
      const Public_Key = await getPulicKey();
      // const Public_Key =
      //   'BPVt0ahvbnH5UYhBLswD4r-YBWWDVFEQR15349Tp6EVze1sVrOLbkg_uyo4HJzo6g9aNG03H63XRdSBEWk8Ahtc';
      // subscribe 会给推送服务器发送一个网络请求
      await registration.pushManager
        .getSubscription()
        .then(function (subscription) {
          isSubscribed = !(subscription === null);
          console.log('Service worker has been registered');
          // TODO: Tell application server to delete subscription
          // return subscription.unsubscribe();
        })
        .catch(function (error) {
          console.log('Error unsubscribing', error);
        });

      if (!isSubscribed) {
        await registration.pushManager
          .subscribe({
            userVisibleOnly: true, // 用于显示请求权限的界面，所以这个值基本必须为true，否则获取不到权限的话，当前promise会被reject
            applicationServerKey: urlB64ToUint8Array(Public_Key),
          })
          .then(function (subscription) {
            // 订阅成功。subscription 就是推送服务器返回的信息
            isSubscribed = true;
            InitWebpush({
              app_id: window.location.host,
              device_id: getDeviceId(),
              subscription: JSON.stringify(subscription),
            }).then(() => {
              console.log('User is subscribed.');
            });
          })
          .catch(function (err) {
            console.log('Failed to subscribe the user: ', err);
          });
      }
    },

    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}, 1000);

// }
